module.exports = __webpack_public_path__ + "img/SOKAL-SRS-121021-Eclipse-Established.eb6ce483.jpeg";